// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"271":"23b7b575","414":"86c53059","453":"abd36b29","600":"b0d3224e"}[chunkId] + ".chunk.js";
};